import { render, staticRenderFns } from "./fiveteen.vue?vue&type=template&id=9cf9a9a0&scoped=true"
import script from "./fiveteen.vue?vue&type=script&lang=js"
export * from "./fiveteen.vue?vue&type=script&lang=js"
import style0 from "./fiveteen.vue?vue&type=style&index=0&id=9cf9a9a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf9a9a0",
  null
  
)

export default component.exports